
define('hbars!bizzabo/templates/ghostSession', ['Handlebars'], function (Handlebars) { return Handlebars.compile('<nav>\n    <h3><em>Tap &amp; Drag</em> to add a new session</h3>\n</nav>'); });

